<template>
  <nav>
    <ul>
      <slot />
    </ul>
  </nav>
</template>
